import React from 'react';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router';
import cx from 'classnames';
import CaretDownFilledIcon from '@/components/icons/CaretDownFilledIcon';
import { HeaderItem } from '@/hooks/header';
import cs from './index.module.scss';

const MenuChildren = ({ data, append }: { data?: HeaderItem[]; append: React.ReactNode }) => {
  if (!data) return null;
  return (
    <div className={cs.menuItemChildrenWrap}>
      <div className={cs.list}>
        {data?.map((item, index) => (
          <a key={index} className={cs.menuItemChildren} href={item?.url}>
            {item?.icon ? <div className={cs.icon}>{item.icon}</div> : null}

            <div className={cs.title}>
              <div>{item.title}</div>
              <div>{item?.subTitle}</div>
            </div>
          </a>
        ))}
      </div>

      {append && <div className={cs.append}>{append}</div>}
    </div>
  );
};

const MenuItem = (props: HeaderItem) => {
  const { title, children, baseUrl, url, icon, append, onClick } = props;
  const { pathname } = useLocation();

  return (
    <div className={cs.menuCol}>
      <a
        className={cx(cs.menuItem, { [cs.active]: baseUrl && pathname.includes(baseUrl) })}
        href={children || onClick ? undefined : url}
        onClick={event => {
          if (!onClick) return;
          event.preventDefault();
          onClick(props);
        }}
      >
        <div style={{ height: '25px' }} className="flex align-items-center">
          {icon}
        </div>
        <div className={cs.title}>{title}</div>
        {children ? <CaretDownFilledIcon className={cs.downIcon} /> : null}
      </a>

      <MenuChildren data={children} append={append} />
    </div>
  );
};

export default observer(MenuItem);
